import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface SiteLayoutProps {
  children: ReactNode;
  flush?: boolean;
}

export default function SiteLayout({ children, flush = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${flush ? '' : 'pt-16 md:pt-[72px]'}`}>{children}</main>
      <Footer />
    </div>
  );
}